export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  paddingBottom: '96px',
};
